import { useState, useEffect } from 'react';

import { userSession } from 'utils/user/userSession';

const useCurrentUserInfo = () => {
  const [userInfo, setUserInfo] = useState();

  useEffect(() => {
    setUserInfo(userSession());
  }, []);

  return userInfo;
};

export default useCurrentUserInfo;
